import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import SafeHTML from '../../security/SafeHtml';
import Translation from '../../../services/translation/Translation';

export interface TimeFormatProps {
  /** The time to display */
  time: Date;
  /** Is the time also displayed */
  isDateWithTime?: boolean;
  /** Is the whole string can be broken */
  isBreaking?: boolean;
}

const TimeFormatDefaultProps = {
  isDateWithTime: false,
  isBreaking: true,
};

const TimeFormat: FC<TimeFormatProps> = ({ time, isDateWithTime, isBreaking }) => {
  const { t } = useTranslation('TimeFormat');
  const { language } = Translation;
  const now = new Date(Date.now());
  let content: string;
  const local = language.startsWith('fr') ? 'fr-CA' : 'en-CA';

  if (isDateWithTime) {
    content = Intl.DateTimeFormat(local, { dateStyle: 'long', timeStyle: 'short' }).format(time);
  } else {
    const dayDiff = dayOfYear(now) - dayOfYear(time);
    if (dayDiff === 0) {
      content = t('today');
    } else if (dayDiff === 1) {
      content = t('yesterday');
    } else if (dayDiff <= 7 && dayDiff > 0) {
      content = time.toLocaleDateString(local, { weekday: 'long' });
    } else if (now.getFullYear() === time.getFullYear()) {
      content = time.toLocaleDateString(local, { month: 'long', day: 'numeric' });
    } else {
      content = time.toLocaleDateString(local, { dateStyle: 'long' });
    }
  }

  return <SafeHTML>{breakStr(content, isBreaking)}</SafeHTML>;
};

const breakStr = (value: string, isBreaking: boolean) => isBreaking ? value : value.replaceAll(' ', '&nbsp;');

const dayOfYear = (date: Date) => ((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / 24 / 60 / 60 / 1000);

TimeFormat.displayName = 'TimeFormat';
TimeFormat.defaultProps = TimeFormatDefaultProps;

export default TimeFormat;
